module.exports = __webpack_public_path__ + "static/media/jessica-vitoria.e0dd5682.jpg";